<template>

    <svg  viewBox="0 0 64.534812 64.089615" version="1.1" id="svg1"
        inkscape:version="1.4.2 (2aeb623e1d, 2025-05-12)" sodipodi:docname="fr.svg"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg">
        
        <defs id="defs1" />
        <g inkscape:label="Layer 1" inkscape:groupmode="layer" id="layer1" transform="translate(-61.977043,-134.20718)">
            <path id="path2-6"
                style="fill:#d11234;fill-opacity:1;stroke:none;stroke-width:0.848;stroke-linecap:round;stroke-linejoin:round"
                d="m 105,135.82051 v 60.70483 c 10.89614,-4.00089 21.51167,-14.03946 21.51186,-30.27309 7e-5,-14.04955 -8.97918,-26.00202 -21.51186,-30.43174 z" />
            <path id="path7"
                style="fill:#0317c2;fill-opacity:1;stroke:none;stroke-width:0.848;stroke-linecap:round;stroke-linejoin:round"
                d="m 83.488394,196.52534 c 107.503446,-5.46621 107.503446,-5.46621 0,0 z m 0,0 v -60.70483 c -12.532682,4.42972 -21.511406,16.38219 -21.511349,30.43174 1.96e-4,16.23363 10.615211,26.2722 21.511349,30.27309 z m 0,-60.70483 c 2.213487,-0.78236 0,0 0,0 z"
                sodipodi:nodetypes="cccccccc" />
            <path id="path2-1"
                style="fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:0.848;stroke-linecap:round;stroke-linejoin:round"
                d="m 94.244584,134.20718 -5.17e-4,64.08962 h 3.589962 c 2.327711,-0.29559 4.753641,-0.8857 7.165971,-1.77146 v -60.70483 c -2.21348,-0.78236 -4.53795,-1.33018 -6.943245,-1.61333 z" />
            <path id="path7-0"
                style="fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:0.848;stroke-linecap:round;stroke-linejoin:round"
                d="m 90.431639,134.20718 c -2.405298,0.28315 -4.729758,0.83097 -6.943245,1.61333 v 60.70483 c 2.412334,0.88577 4.838771,1.47587 7.166487,1.77146 h 3.589445 v -64.08962 z" />
        </g>
    </svg>

</template>